import React from 'react'
import PropTypes from 'prop-types'
import { ImageStyles } from './styles'

const ImageProject = ({urlImage, name}) => {
  return (
    <ImageStyles src={urlImage} alt={name} data-testid='element-image'/>
  )
}

ImageProject.propTypes = {
  urlImage: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default ImageProject
